import React, { Component } from 'react';


/*DIALOG DEPENDENCIES */
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import CreateCost from './CreateCost';


/*Events and Styling */
const styles = {
  appBar: {
    position: 'relative',
  },
  flex: {
    flex: 1,
  },
  toolbar:{
    backgroundColor:"#243043"
  }, 
  paperFullScreen:{
    backgroundColor:"#f9f9fa"
  }
};

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

class CreateCostModel extends Component {
  static propTypes = {

  };

  render() {
    const { classes } = this.props;
    return (
       <div>
        <Dialog
          fullScreen
          open={this.props.openDialog}
          onClose={this.props.closeDialog}
          TransitionComponent={Transition}
          classes={{
            paperFullScreen:classes.paperFullScreen
          }}
        >
          <AppBar className={classes.appBar}>
            <Toolbar className={classes.toolbar}>
              <IconButton color="inherit" onClick={this.props.closeDialog} aria-label="Close">
                <CloseIcon />
              </IconButton>
              <Typography variant="h6" color="inherit" className={classes.flex}>
                Close 
              </Typography>
            </Toolbar>
          </AppBar>
          <CreateCost 
            workpackage_name={this.props.workpackage_name}
            deliverable={this.props.deliverable}
            costEdit={this.props.costEdit} 
            actionDialog={this.props.actionDialog} 
            workpackage={this.props.workpackage} 
            ca={this.props.ca} 
            project={this.props.project}
            onCloseAction={this.props.closeDialog}/>
        </Dialog>
      </div>
    );
  }
}


export default withStyles(styles)(CreateCostModel);




// WEBPACK FOOTER //
// ./src/features/cost/CreateCostModel.js